module.exports = __webpack_public_path__ + "static/qr-code-e536d810388e03dc3f1d6ad1481bf84a.png";